<template>
  <div class="mmain">
    <div class="program">
      <div class="showSomeProgram">
        <div class="pabs">
          <h2>{{ newsData.name }}</h2>
          <h4>
            <span>{{ newsData.magtime }}</span>
            <span>浏览量 : {{ newsData.magcount }}</span>
          </h4>
          <div class="line"></div>
          <div class="pabsContent" v-html="newsData.magtext"></div>
        </div>
        <div class="rebtn">
          <el-button @click="ret" type="primary">返回列表</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfoDetail } from "@/api/news.js";
import Bus from "@/utils/bus.js";
import { BASE_URL } from "@/utils/base.js";
export default {
  name: "Home",
  data() {
    return {
      url: "",
      newsData: {},
    };
  },
  mounted() {
    window.scrollTo({
      top: 0,
    });
    this.getData();
    // this.$nextTick(function() {
    //   if (newsData.vypublic == "活动展示") {
    //     Bus.$emit("getCurrent", "news");
    //   } else {
    //     Bus.$emit("getCurrent", "news");
    //   }
    // });
    // this.$nextTick(()=>{
    //  this.$refs.myVideo.src = "../../assets/demo.mp4";
    // })
  },
  methods: {
    // 获取数据
    async getData() {
      let news = new FormData();
      news.append("sids", this.$route.params.id);
      let data = await getInfoDetail(news);
      this.newsData = data;
      this.newsData.magtime = this.newsData.magtime.substring(0, 10);
    },
    // 返回上一页
    ret() {
      this.$router.go(-1);
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.mmain {
  width: 100%;
  margin-top: 190px;
  .program {
    width: calc(100vw - 60px);
    margin: 0 auto;
    background-color: #fff;
    .showSomeProgram {
      width: 100%;
      margin: 0 auto;
      .pabs {
        width: 100%;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        color: #000;
        h2 {
          font-size: 32px;
          color: #333;
          line-height: 1.3;
          text-align: center;
          margin-bottom: 20px;
        }
        .line{
          width: 100%;
          height: 2px;
          background-color: #b2b2b2;
          margin-bottom: 30px;
        }
        .pabsContent {
          line-height: 1.5;
        }
        h4 {
          display: flex;
          margin-bottom: 20px;
          justify-content:center;
          font-size: 24px;
          color: #959595;
          span {
            margin-right: 10px;
          }
        }
      }
      .rebtn {
        text-align: center;
        margin-top: 60px;
        margin-bottom: 80px;
      }
    }
  }
}
</style>